import AppCopy from "../../AppComponents/AppCopy";
import { GeneralResponse } from "../GPTConvoTypes";

export default function GeneralMessage({
  message,
}: {
  message: GeneralResponse;
}) {
  return (
    <div className="px-2 pb-2" style={{ whiteSpace: "pre-wrap" }}>
      <div className="d-flex justify-content-end">
        <AppCopy
          text={message?.Text || message?.Message}
          tooltipText="Copy Message"
          style={{ height: 22, width: 22 }}
          iconStyle={{ fontSize: 16 }}
        />
      </div>
      {message?.Text || message?.Message}
    </div>
  );
}
